import { NodeProperties } from '../../../model/client-model/properties/node.properties';

/**
 * For legacy reasons, there is one property on the nodeProperties saying which TE it represents,
 * and one property deeper in the object that says which TE is instantiated.
 */
export function envelopeTEMatchesInstantiatedTE(nodeProperties: NodeProperties): boolean {
  const envelopeTE = nodeProperties?.transitionElement;
  const instantiatedTE = nodeProperties?.transitionTargetData?.transitionTargetProperties?.transitionElement;
  return envelopeTE === instantiatedTE;
}
